module.exports = __webpack_public_path__ + "static/media/coinbase-wallet.39ab10d5.svg";